import { useState } from 'react';
import { motion } from 'motion/react';
import { Plus, Search, Edit, Trash2 } from 'lucide-react';

const PACKAGING_DATA = [
  { id: 1, name: "-", unit: "Pcs", quantity: 1 },
  { id: 2, name: "Bag-100", unit: "Pcs", quantity: 100 },
  { id: 3, name: "Bag-200", unit: "Pcs", quantity: 200 },
  { id: 4, name: "Bag-250", unit: "Pcs", quantity: 250 },
  { id: 5, name: "Bag-500", unit: "Pcs", quantity: 500 },
  { id: 6, name: "Bag-1K", unit: "Pcs", quantity: 1000 },
  { id: 7, name: "Bag-2K", unit: "Pcs", quantity: 2000 },
  { id: 8, name: "Bag-5K", unit: "Pcs", quantity: 5000 },
  { id: 9, name: "Reel-750", unit: "Pcs", quantity: 750 },
  { id: 10, name: "Reel-1K", unit: "Pcs", quantity: 1000 },
  { id: 11, name: "Reel-1.8K", unit: "Pcs", quantity: 1800 },
  { id: 12, name: "Reel-2K", unit: "Pcs", quantity: 2000 },
];

export const Packaging = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredPackaging = PACKAGING_DATA.filter(pkg => 
    pkg.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white dark:bg-slate-800 rounded-sm shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col h-[calc(100vh-12rem)] text-slate-800 dark:text-slate-200">
      <div className="p-4 border-b border-slate-100 dark:border-slate-700/50 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white dark:bg-slate-800">
        
        <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl text-sm font-medium flex items-center gap-2 shrink-0 transition-colors shadow-sm">
          <Plus size={18} />
          <span>بسته‌بندی جدید</span>
        </button>

        <div className="flex items-center gap-2">
          <label className="text-sm px-2 text-slate-700 dark:text-slate-300">جست و جو</label>
          <div className="w-64">
            <input 
              type="text" 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-1.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg text-sm focus:outline-none focus:border-blue-500 dark:text-white"
              dir="rtl"
            />
          </div>
        </div>

      </div>
      
      <div className="overflow-auto flex-1 bg-slate-100 dark:bg-slate-900" dir="ltr">
        <table className="w-full text-left table-auto border-collapse bg-white dark:bg-slate-800">
          <thead className="bg-[#f0f0f0] dark:bg-slate-900 border-b border-slate-400 dark:border-slate-600 text-slate-800 dark:text-slate-300 text-[13px] sticky top-0 z-10 whitespace-nowrap">
            <tr>
              <th className="px-2 py-1 font-normal w-12 text-center border-r border-slate-300 dark:border-slate-600">#</th>
              <th className="px-2 py-1 font-normal w-1/4 text-left border-r border-slate-300 dark:border-slate-600">نام</th>
              <th className="px-2 py-1 font-normal w-1/4 text-left border-r border-slate-300 dark:border-slate-600">واحد</th>
              <th className="px-2 py-1 font-normal w-1/4 text-left border-r border-slate-300 dark:border-slate-600">مقدار در واحد</th>
              <th className="px-2 py-1 font-normal w-24 text-center">عملیات</th>
            </tr>
          </thead>
          <tbody className="">
            {filteredPackaging.map((pkg, index) => (
              <tr 
                key={pkg.id} 
                className={`cursor-pointer border-b border-slate-200 dark:border-slate-700/50 ${index === 0 ? 'bg-[#0078d7] text-white hover:bg-[#006cc1]' : 'even:bg-[#fbf9f6] odd:bg-white dark:even:bg-slate-800 dark:odd:bg-slate-800/80 hover:bg-blue-50 dark:hover:bg-blue-900/20 text-slate-800 dark:text-slate-300'}`}
              >
                <td className={`px-2 py-1 text-[13px] text-center border-r border-slate-300 dark:border-slate-600 ${index === 0 ? 'border-white/20' : ''}`}>
                  {pkg.id}
                </td>
                <td className={`px-2 py-1 text-[13px] text-left border-r border-slate-300 dark:border-slate-600 ${index === 0 ? 'border-white/20' : ''}`}>
                  {pkg.name}
                </td>
                <td className={`px-2 py-1 text-[13px] text-left border-r border-slate-300 dark:border-slate-600 ${index === 0 ? 'border-white/20' : ''}`}>
                  {pkg.unit}
                </td>
                <td className={`px-2 py-1 text-[13px] text-left border-r border-slate-300 dark:border-slate-600 ${index === 0 ? 'border-white/20' : ''}`}>
                  {pkg.quantity}
                </td>
                <td className="px-2 py-1 text-center">
                  <div className="flex items-center justify-center gap-2">
                    <button className={`p-1.5 rounded transition-colors ${index === 0 ? 'hover:bg-white/20 text-white' : 'hover:bg-slate-200 dark:hover:bg-slate-700 text-blue-600 dark:text-blue-400'}`}>
                      <Edit size={14} />
                    </button>
                    <button className={`p-1.5 rounded transition-colors ${index === 0 ? 'hover:bg-white/20 text-white' : 'hover:bg-slate-200 dark:hover:bg-slate-700 text-red-600 dark:text-red-400'}`}>
                      <Trash2 size={14} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

